var _path, _path2, _circle, _circle2, _circle3, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8ControlPanel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: "50px",
    height: "50px",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6693c1",
    d: "M71,82H29c-6.075,0-11-4.925-11-11V29c0-6.075,4.925-11,11-11h42c6.075,0,11,4.925,11,11v42 C82,77.075,77.075,82,71,82z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9dc4e8",
    d: "M77.5,29v42c0,3.575-2.925,6.5-6.5,6.5H29c-3.575,0-6.5-2.925-6.5-6.5V29 c0-3.575,2.925-6.5,6.5-6.5h42C74.59,22.5,77.5,25.41,77.5,29z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 54.5,
    r: 3,
    fill: "#fefdef"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 42.5,
    r: 3,
    fill: "#fefdef"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.5,
    cy: 54.5,
    r: 3,
    fill: "#fefdef"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#c6dff1",
    d: "M29.5,40.5c0-4.142,3.358-7.5,7.5-7.5s7.5,3.358,7.5,7.5H29.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M71,78H29c-3.86,0-7-3.141-7-7V29c0-3.859,3.14-7,7-7h37.5c0.276,0,0.5,0.224,0.5,0.5 S66.776,23,66.5,23H29c-3.309,0-6,2.691-6,6v42c0,3.309,2.691,6,6,6h42c3.309,0,6-2.691,6-6V51c0-0.276,0.224-0.5,0.5-0.5 S78,50.724,78,51v20C78,74.859,74.86,78,71,78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M77.5,48c-0.276,0-0.5-0.224-0.5-0.5v-4c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v4 C78,47.776,77.776,48,77.5,48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M77.5,42c-0.276,0-0.5-0.224-0.5-0.5v-2c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v2 C78,41.776,77.776,42,77.5,42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M71,83H29c-6.617,0-12-5.383-12-12V29c0-6.617,5.383-12,12-12h42c6.617,0,12,5.383,12,12v42 C83,77.617,77.617,83,71,83z M29,19c-5.514,0-10,4.486-10,10v42c0,5.514,4.486,10,10,10h42c5.514,0,10-4.486,10-10V29 c0-5.514-4.486-10-10-10H29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M52.5,71c-0.276,0-0.5-0.224-0.5-0.5v-11c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v11 C53,70.776,52.776,71,52.5,71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M52.5,58c-1.93,0-3.5-1.57-3.5-3.5s1.57-3.5,3.5-3.5s3.5,1.57,3.5,3.5S54.43,58,52.5,58z M52.5,52 c-1.378,0-2.5,1.121-2.5,2.5s1.122,2.5,2.5,2.5s2.5-1.121,2.5-2.5S53.878,52,52.5,52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M60.5,46c-1.93,0-3.5-1.57-3.5-3.5s1.57-3.5,3.5-3.5s3.5,1.57,3.5,3.5S62.43,46,60.5,46z M60.5,40 c-1.378,0-2.5,1.121-2.5,2.5s1.122,2.5,2.5,2.5s2.5-1.121,2.5-2.5S61.878,40,60.5,40z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M68.5,58c-1.93,0-3.5-1.57-3.5-3.5s1.57-3.5,3.5-3.5s3.5,1.57,3.5,3.5S70.43,58,68.5,58z M68.5,52 c-1.378,0-2.5,1.121-2.5,2.5s1.122,2.5,2.5,2.5s2.5-1.121,2.5-2.5S69.878,52,68.5,52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M52.5,52c-0.276,0-0.5-0.224-0.5-0.5v-21c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v21 C53,51.776,52.776,52,52.5,52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M60.5,71c-0.276,0-0.5-0.224-0.5-0.5v-23c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v23 C61,70.776,60.776,71,60.5,71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M60.5,40c-0.276,0-0.5-0.224-0.5-0.5v-9c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v9 C61,39.776,60.776,40,60.5,40z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M68.5,71c-0.276,0-0.5-0.224-0.5-0.5v-11c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v11 C69,70.776,68.776,71,68.5,71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M68.5,52c-0.276,0-0.5-0.224-0.5-0.5v-21c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v21 C69,51.776,68.776,52,68.5,52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M44.5,47h-15c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h15c0.276,0,0.5,0.224,0.5,0.5 S44.776,47,44.5,47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M44.5,52h-15c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h15c0.276,0,0.5,0.224,0.5,0.5 S44.776,52,44.5,52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M39.5,57h-10c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h10c0.276,0,0.5,0.224,0.5,0.5 S39.776,57,39.5,57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M44.5,41h-15c-0.276,0-0.5-0.224-0.5-0.5c0-4.411,3.589-8,8-8s8,3.589,8,8 C45,40.776,44.776,41,44.5,41z M30.018,40h13.965c-0.257-3.627-3.291-6.5-6.982-6.5S30.275,36.373,30.018,40z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M37,41c-0.113,0-0.226-0.038-0.32-0.116c-0.212-0.177-0.241-0.492-0.064-0.704l2.5-3 c0.177-0.211,0.491-0.241,0.705-0.063c0.212,0.177,0.241,0.492,0.064,0.704l-2.5,3C37.285,40.938,37.143,41,37,41z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8ControlPanel);
export default __webpack_public_path__ + "static/media/icons8-control-panel.2d5bf380ad06a1ce7a4a662cb431513a.svg";
export { ForwardRef as ReactComponent };